import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useSelector } from '../../node_modules/react-redux';
import { PaymentProviders } from '../../utils/paymentProviders';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { PLATFORM } from '../../constants';
import Utils from '../../utils';
import Logger from '../../lib/analytics/logger';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
export default function useSendInitiatePurchaseLog() {
  var coin = useSelector(function (state) {
    return state.coin;
  });
  var gameInfo = useSelector(function (state) {
    return state.gameInfo;
  });
  var sendInitiatePurchaseLog = function sendInitiatePurchaseLog(_ref) {
    var sku = _ref.sku,
      amount = _ref.amount,
      pType = _ref.pType,
      trigger = _ref.trigger,
      UUID = _ref.UUID;
    var platform = Utils.getPlatform();
    var store = getStoreBasedOnPlatform[platform];
    var eventPayload = {
      type: pType,
      product_id: sku,
      currency: PURCHASE_CURRENCY,
      store: store,
      balance_before: coin.value,
      is_test: ENVIRONMENT_VARIABLES.ENVIRONMENT !== 'PROD' ? 1 : 0,
      amount: amount,
      id: UUID,
      trigger: trigger,
      game_provider: gameInfo.gameProvider,
      game_id: gameInfo.gameId
    };
    Logger.sendEvent(EVENT_TYPES.TRANSACTION_INITIATED, eventPayload);
  };
  return {
    sendInitiatePurchaseLog: sendInitiatePurchaseLog
  };
}
var APPLE_STORE_KEY = 'appstore';
var PURCHASE_CURRENCY = 'usd';
var getStoreBasedOnPlatform = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PLATFORM.IOS, APPLE_STORE_KEY), PLATFORM.ANDROID, PLATFORM.ANDROID), PLATFORM.WEB, PaymentProviders.CAMS), PLATFORM.MOBILE_WEB, PaymentProviders.CAMS);